module.exports = __webpack_public_path__ + "static/img/bb2.c96a124.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bb2.png
// module id = 3OTH
// module chunks = 1